import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Field } from '../components/Field';
import { useDict } from '../i18n/dictionary';
import { shell } from '../i18n/shell';
import { useAuth } from '../lib/auth';
import { toast } from '../lib/toast';

export function Login() {
  const { signIn } = useAuth();
  const t = useDict(shell);
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    const failure = await signIn(login, password);
    setSubmitting(false);
    if (failure) {
      toast.error(t.signInFailed);
      return;
    }
    void navigate('/apps', { replace: true });
  }

  return (
    <main className="center-screen">
      <section className="card-narrow">
        <div className="card-accent"></div>
        <div className="card-body">
          <Link to="/" className="wordmark-md">
            IT<span className="wordmark-accent">Lamb</span>
          </Link>
          <p className="form-hint">{t.signInPrompt}</p>
          <form onSubmit={(e) => void onSubmit(e)} className="form-stack">
            <Field
              id="login"
              label={t.login}
              name="login"
              type="text"
              autoComplete="username"
              required
              value={login}
              onChange={(e) => setLogin(e.target.value)}
            />
            <Field
              id="password"
              label={t.password}
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="submit"
              className="btn-primary-block"
              disabled={submitting}
            >
              {t.signIn}
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}
